import { IConcept } from '@cbgms/api/modules/concepts'
import { isRequired } from '@cbgms/base/utils/validations'
import React from 'react'
import { useTranslation } from 'react-i18next'
import FormikFormLayout, { IDeleteOptions } from 'core/page/layout/FormikFormLayout'
import { Form, FormProps } from '@carsys/form'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { TextField } from '@carsys/form/src/TextField'
import { Checkbox } from '@carsys/form/src/Checkbox'

interface Props extends FormProps<IConcept, IConcept> {
  form: string
  deleteOptions?: IDeleteOptions
}

const ConceptForm: React.FC<Props> = props => {
  const { form, deleteOptions, ...formProps } = props
  const { t } = useTranslation()
  const iFrameIsSupportedFieldName = 'IFrameIsSupported'

  return (
    <Form formID={form} {...formProps}>
      {formikBag => (
        <FormikFormLayout
          title={<Typography variant='h5'>{t('Concepts.Settings.GeneralTitle')}</Typography>}
          backButtonProps={{ to: '/external-gms' }}
          deleteOptions={deleteOptions}
        >
          <Box>
            <Box display='flex' gap={2} my={2}>
              <TextField label={t('entities.concept.name')} name='Name' required validate={isRequired} />
              <TextField label={t('entities.concept.conceptnumber')} name='ConceptNumber' required validate={isRequired} />
            </Box>
            <Box display='flex' gap={2} my={2}>
              <TextField label={t('entities.concept.subscriptionkey')} name='SubscriptionKey' required validate={isRequired} />
              <TextField label={t('entities.concept.subscriptionkeyappointment')} name='SubscriptionKeyAppointment' />
              <TextField label={t('entities.concept.subscriptionkeyfrontoffice')} name='SubscriptionKeyFrontOffice' />
            </Box>
          </Box>
          <Box>
            <Typography variant='h5'>{t('Concepts.Settings.IFrameTitle')}</Typography>
            <Box>
              <Checkbox name={iFrameIsSupportedFieldName} label={t('entities.concept.iframeissupported')} />
            </Box>
            <Box>
              <TextField
                multiline
                rows={10}
                disabled={!formikBag.values.IFrameIsSupported}
                required={formikBag.values.IFrameIsSupported}
                validate={formikBag.values.IFrameIsSupported ? isRequired : undefined}
                label={t('global.termsAndConditions')}
                name='IFrameTermsAndConditions'
              />
            </Box>
          </Box>
        </FormikFormLayout>
      )}
    </Form>
  )
}

ConceptForm.displayName = 'ConceptForm'

export default ConceptForm
